import axios, { AxiosInstance } from "axios";
import { baseGatewayApi, baseGatewayApiTest } from '../config/index';
// import qs from 'query-string';
const qs = require('query-string');
// import CryptoJS from "crypto-js";


export default function createGwInstance(signUrl: string, isDEV: boolean): AxiosInstance {

  const gwApiInstance = axios.create({
    baseURL: isDEV ? baseGatewayApiTest : baseGatewayApi,
    headers: {
      'Accept': 'application/json',
    },
    timeout: 3000,
  });

  gwApiInstance.interceptors.request.use(
    async (config) => {
      const queryString = qs.stringify(config.params)
      const options = {
        method: config.method!.toUpperCase(),
        headers: {
          "Accept": config.headers!.Accept,
          "Content-Type": config.headers!['content-type'],
          "Content-MD5": config.headers!['Content-MD5'],
        },
        path: `${config.url}${queryString ? `?${queryString}` : ""}`
      }
      const res = await axios.post(signUrl, options);
      const { authorization, dateTime } = res.data;
      config.headers!['X-Date'] = dateTime;
      config.headers!.Authorization = authorization;
      // const dateTime = new Date().toUTCString()
      // const signingStr = [
      //   `x-date: ${dateTime}`,
      //   config.method!.toUpperCase(),
      //   config.headers!.Accept,
      //   config.headers!['content-type'],
      //   config.headers!['Content-MD5'],
      //   config.url,
      // ].join('\n')
      // const signing = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA1(signingStr, apiAppSecret));
      // const sign = `hmac id="${apiAppKey}", algorithm="hmac-sha1", headers="x-date", signature="${signing}"`
      // config.headers!['X-Date'] = dateTime;
      // config.headers!.Authorization = sign;
      return config;
    },
    (error) => error
  );
  return gwApiInstance;
};
